import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import {
  convertBefehl7FormDataToModel,
  convertModelToBefehl7FormData
} from './converters'
import Auftrag7_10Form from './Auftrag7_10Form'
import Auftrag7_20Form from './Auftrag7_20Form'
import { AuftragX_25Form } from '../Auftraege'
import { useBefehlForm } from '../../../hooks'
import { BefehlFormWrapper, BefehlFormProps } from '../Generic'
import { Befehl7 } from '../../../models'
import { Befehl7FormData, createBefehl7FormValidationSchema } from './schema'

/**
 * Main form component for Befehl 7
 */
export default function Befehl7Form({
  befehl,
  onSubmit,
  readOnly = false,
  'data-testid': testId = 'befehl-7-form',
  activateEmptyFieldWarnings = false,
  displayHeaderOnly = false
}: Readonly<BefehlFormProps<Befehl7>>) {
  const { t } = useTranslation('ui-befehle')

  const formMethods = useBefehlForm<
    ReturnType<typeof createBefehl7FormValidationSchema>
  >({
    readOnly,
    activateEmptyFieldWarnings,
    schema: createBefehl7FormValidationSchema(),
    initialData: befehl ? convertModelToBefehl7FormData(befehl) : undefined
  })

  const handleSubmit = useCallback(
    (data: Befehl7FormData) => {
      const updatedBefehl = convertBefehl7FormDataToModel(
        data,
        befehl.frontendId
      )
      onSubmit(updatedBefehl)
    },
    [befehl.frontendId, onSubmit]
  )

  return (
    <BefehlFormWrapper<Befehl7FormData>
      befehlKennung="7"
      title={t('befehle.7.description')}
      formMethods={formMethods}
      onSubmit={handleSubmit}
      readOnly={readOnly}
      data-testid={`${testId}-wrapper`}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      displayHeaderOnly={displayHeaderOnly}
    >
      {/* Auftrag 7.10 */}
      <Auftrag7_10Form
        data-testid={`${testId}-auftrag-7-10`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />
      {/* Auftrag 7.20 */}
      <Auftrag7_20Form
        readOnly={readOnly}
        fieldPrefix={'auftrag_7_20'}
        data-testid={`${testId}-auftrag-7-20`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />
      {/* Auftrag 7.25 */}
      <AuftragX_25Form
        befehlKennung="7"
        fieldNamePrefix="auftrag_7_25"
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-7-25`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />
    </BefehlFormWrapper>
  )
}
